import axios, { AxiosRequestConfig } from 'axios';
import { BASE_RDS, DEFAULT_RDS_PORT } from 'src/common/helpers/config';
import XLRLogger from 'src/common/helpers/logger';
import { DeviceResponse } from 'src/devices/rds-connection';
import { getMetaData } from 'src/xlr-configuration/pos-service-type-utils';

export const sendCheckDetailsRequest = async (name: string): Promise<DeviceResponse> => {
  const loggerSource = 'devices/micr-operations.ts';
  const { RDS_HOSTNAME = BASE_RDS, RDS_PORT = DEFAULT_RDS_PORT } = getMetaData().xlrConfig;
  const options: AxiosRequestConfig = {
    method: 'GET',
    url: `/${name}`,
    baseURL: `http://${RDS_HOSTNAME}:${RDS_PORT}/micr`,
  };
  XLRLogger.info({
    message: 'RDS Get Check Details Request',
    source: loggerSource,
    data: options,
  });
  return axios
    .request<DeviceResponse>(options)
    .then(response => {
      XLRLogger.info({
        message: 'RDS Get Check Details Response',
        source: loggerSource,
        data: response,
      });
      return response.data;
    })
    .catch(err => {
      XLRLogger.error({
        message: 'RDS Get Check Details Response',
        source: 'tendering/components/process-tender/micr-validation-view.tsx',
        data: err,
      });
      throw err;
    });
};
